var map = {
	"./locale-provider/de_DE.tsx": 718,
	"./locale-provider/en_US.tsx": 719,
	"./locale-provider/es_ES.tsx": 720,
	"./locale-provider/fr_BE.tsx": 721,
	"./locale-provider/pt_BR.tsx": 722,
	"./locale-provider/ru_RU.tsx": 723,
	"./locale-provider/sv_SE.tsx": 725
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 685;



/*****************
 ** WEBPACK FOOTER
 ** ./components ^\.\/locale-provider\/.+_.+\.tsx$
 ** module id = 685
 ** module chunks = 1
 **/